import React from 'react';
import { concatStyles } from 'utils';
var CONTAINER_STYLES = 'flex flex-row w-screen h-auto box-border m-0';
export var Container = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: concatStyles([CONTAINER_STYLES, className]) }, children));
};
